<template>
    <b-modal v-model="show" size="lg" title="Ёрдамчи бинолар"
             :no-close-on-backdrop="true" :no-close-on-esc="true"
             :hide-footer="true" :hide-header-close="true">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="text-center">
              <p>Майдонлар орасидаги фарқ 30% дан ошди илтимос ёрдамчи бинони танланг!</p>
            </div>
            <div class="form-group">
              <label>Ёрдамчи бинолар <span class="red">*</span></label>
              <treeselect v-model="data.cadastreBuildings"
                          class="form-control"
                          placeholder="Танланг..."
                          :options="cadastreBuildings"
                          :multiple="true"
              >
              </treeselect>
              <div v-if="$v.data.buildings.$error" class="red">
                Илтимос ёрдамчи бинони танланг!
              </div>
              <!--<v-select-->
                <!--v-model="cadastreBuilding"-->
                <!--label="name"-->
                <!--:filterable="false"-->
                <!--:options="cadastreBuildings"-->
                <!--@search="onSearchCadastreBuilding"-->
                <!--@input="onChangeBuildingComparative"-->
              <!--&gt;</v-select>-->
              <!--<div v-if="$v.cadastreBuilding.code.$error" class="red">-->
                <!--Илтимос ёрдамчи бинони танланг!-->
              <!--</div>-->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 btns-box">
            <button class="all-btn btn-default" v-if="!hasSelected" :disabled="processing" @click="onOther">Бошқа</button>
            <button class="all-btn add-btn" v-else-if="hasSelected" :disabled="processing" @click="onChangeBuildingComparative">Тасдиқлаш</button>
            <button class="all-btn delete-btn" @click="show =!show">Мавжуд эмас</button>
          </div>
        </div>
      </div>
    </b-modal>
</template>

<script>
  import initFilterModel from '@/shared/filter';
  import {requiredUnless} from 'vuelidate/lib/validators';
  import {validationMixin} from 'vuelidate';
  import bModal from 'bootstrap-vue/es/components/modal/modal';
  import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';
  import Treeselect from '@riophae/vue-treeselect';

  export default {
    name: "RealEstateCostModal",
    mixins: [validationMixin],
    components: {
        'b-modal': bModal,
        Treeselect
    },
    directives: {
        'b-modal': bModalDirective
    },
    data() {
      return {
        show: false,
        processing: false,
        cadastreSectionFilter: initFilterModel(),
        realEstateId: null,
        realEstate: null,
        data: {
            realEstateId: ((this.$route.params.id && this.$route.params.id > 0) ? this.$route.params.id : null),
            cadastreBuildings: []
        },
        cadastreBuilding: null,
        cadastreBuildings: []
      }
    },
    validations() {
      return {
        data: {
            buildings: {
                required: requiredUnless(() => {
                    return !!(this.data.cadastreBuildings && this.data.cadastreBuildings.length > 0)
                })
            }
        }
      }
    },
    computed: {
        hasSelected() {
            return this.data.cadastreBuildings && this.data.cadastreBuildings.length > 0
        }
    },
    methods: {
      cadastreBuildingInit() {
          this.cadastreBuildings = [];
          this.cadastreSectionFilter.page.size = 1000;
          this.cadastreSectionFilter.cadastreSectionCode = 'TerraceAndOtherBuildings';

          this.$http.post('cadastre/building/search', this.cadastreSectionFilter)
              .then(res => {
                  if (res.data.data && res.data.data.length > 0) {
                      this.cadastreBuildings = res.data.data.map((item) => {
                          item.label = item.name
                          return item;
                      });
                  }
                  // const data = {
                  //     code: 'OtherBuilding',
                  //     name: 'Бошқа',
                  //     nameRu: 'Прочий'
                  // }
                  // this.cadastreBuildings.push(data)
              }, err => {
                  console.log(err);
              });
      },
      onSearchCadastreBuilding(searchTxt, loading) {
          loading(true);
          this.cadastreBuildings = [];
          this.cadastreSectionFilter.page.size = 1000;
          this.cadastreSectionFilter.search = searchTxt;
          this.cadastreSectionFilter.cadastreSectionCode = 'TerraceAndOtherBuildings';

          this.$http.post('cadastre/building/search', this.cadastreSectionFilter)
              .then(res => {
                  this.cadastreBuildings = res.data.data;
                  const data = {
                      code: 'OtherBuilding',
                      name: 'Бошқа',
                      nameRu: 'Прочий'
                  }
                  this.cadastreBuildings.push(data)
                  loading(false);
              }, err => {
                  console.log(err);
              });
      },
      onChangeBuildingComparative() {

          this.$v.$touch();
          if (this.$v.$invalid) {
            return;
          }

          // if (this.cadastreBuilding && this.cadastreBuilding.code === 'OtherBuilding') {
          //   this.show = false
          //   return
          // }

          this.processing = true;

          // this.building.cadastreBuilding = this.cadastreBuilding
          // this.building.name = this.cadastreBuilding.name;
          this.data.realEstateId = this.realEstateId

          this.$http.post('new-real-estate/building-comparative', this.data)
              .then(res => {
                  if (res.data && res.data.status === 'SUCCESS') {
                      this.show = false
                      if (this.realEstate.category === 'Residential') {
                          this.$router.push('/new-real-estate/residential');
                      } else {
                          this.$router.push('/new-real-estate/notorious');
                      }
                  } else {
                      this.$swal({
                          title: this.$t('messages.common.error'),
                          text: res.data.message,
                          type: 'error'
                      });
                  }
                  this.processing = false;
              }, () => {
                  this.$swal({
                      title: this.$t('messages.common.error'),
                      text: this.$t('messages.building.error'),
                      type: 'error'
                  });
                  this.processing = false;
              });
      },
      onOther() {
          this.$swal({
              title: '',
              text: 'Ёрдамчи бинолар мавжуд эмаслигига ишончингиз комилми?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#78b414',
              confirmButtonText: this.$t('realEstate.action.confirm'),
              cancelButtonText: this.$t('action.cancel')
          }).then((result) => {
              if (result.value) {
                  this.processing = true;

                  this.realEstate.areasDifferenceEnabled = false
                  this.$http.post(`/real-estate-new/save/assistant-building/${this.realEstate.id}`, this.realEstate)
                      .then(res => {
                          if (res.data && res.data.status === 'SUCCESS') {
                              this.show = false
                          }
                          this.processing = false;
                      }, () => {
                          this.processing = false;
                      })
              }
          });
      }
    },
    created() {
      this.$eventBus.$on('showRealEstateCostModal', (realEstate) => {
          if (realEstate && realEstate.id > 0) {
              this.realEstateId = realEstate.id;
              this.realEstate = realEstate
              this.cadastreBuildingInit();
              this.show = true;
          }
      })
    }
  }
</script>

<style scoped>

</style>
